module.exports = __webpack_public_path__ + "static/media/mask_v2_ca.2c505dbb.png";